itsoftApp.createModule("toggleTabs", function() {
    var module = this;

    // var tabs = document.querySelectorAll('.js-tabs-section');

    var deletePopupHandler = function (el) {
        if (el.classList.contains("js-open-popup")) {
            el.classList.remove("js-open-popup");
            el.removeAttribute("data-popup-selector");
        }
    }

    var initTabToggle = function(tabs) {
        var tabs = tabs;
        var isContainingTabs = tabs.hasAttribute("data-containing-tabs");
        var tabsItems;
        var currentActiveTab;
        var currentActiveContents;
        if (isContainingTabs) {
            tabsItems = tabs.querySelectorAll("[data-parent-tabs] .js-tab-name");
            currentActiveTab = tabs.querySelector("[data-parent-tabs] .js-tab-name--active");
            currentActiveContents = tabs.querySelectorAll("[data-parent-content].js-tab-content--active");
        } else {
            tabsItems = tabs.querySelectorAll(".js-tab-name");
            currentActiveTab = tabs.querySelector(".js-tab-name--active");
            currentActiveContents = tabs.querySelectorAll(".js-tab-content--active");
        }

        var dataActiveSectionClass;
        var dataActiveSectionSelector;
        var sectionElement;
        var hash = location.hash;

        var goToHash = function (newHash) {
            var element;
            var contentElements;

            if (newHash) {
                var selector = "[data-tab-selector='" + newHash + "']";
                var contentSelector = "[data-content-url='" + newHash + "']";
                element = tabs.querySelector(selector);
                contentElements = tabs.querySelectorAll(contentSelector);
            } else {
                element = tabsItems[0];
                var contentSelector = "[data-content-url='" + element.getAttribute("data-tab-selector") + "']";
                contentElements = tabs.querySelectorAll(contentSelector);
            }

            if (element) {
                goToTab(element, contentElements);
            }
        }

        var goToTab = function (tab, contents) {
            deletePopupHandler(tab);
            currentActiveTab.classList.remove("js-tab-name--active");
            Array.prototype.forEach.call(currentActiveContents, function (currentActiveContent) {
                currentActiveContent.classList.remove("js-tab-content--active");
            });
            if (dataActiveSectionClass) {
                sectionElement.classList.remove(dataActiveSectionClass);
            }
            currentActiveTab = tab;
            dataActiveSectionSelector = tab.getAttribute("data-section-selector");
            if (dataActiveSectionSelector) {
                sectionElement = document.querySelector(dataActiveSectionSelector);
            }

            dataActiveSectionClass = tab.getAttribute("data-section-class");

            if (dataActiveSectionClass) {
                sectionElement.classList.add(dataActiveSectionClass);
            }

            currentActiveContents = contents;
            currentActiveTab.classList.add("js-tab-name--active");
            Array.prototype.forEach.call(currentActiveContents, function (currentActiveContent) {
                currentActiveContent.classList.add("js-tab-content--active");
            });
        }

        var onTabClick = function (currentTab) {
            var tabSelector;
            // if (evt.target.hasAttribute("data-tab-selector")) {
            //     tabSelector = evt.target.getAttribute("data-tab-selector");
            //     location.hash = tabSelector;
            // } else 
            if (currentTab.hasAttribute("data-tab-selector")) {
                tabSelector = currentTab.getAttribute("data-tab-selector");
                location.hash = tabSelector;
            }
            // currentIndex = index; // ???
            var tabsContents = tabs.querySelectorAll("[data-content-url='" + tabSelector + "']");
            goToTab(currentTab, tabsContents);
        }

        var addTabClickListener = function (tab) {
            tab.addEventListener("click", function (evt) {
                evt.preventDefault();
                onTabClick(tab);
            });
        }

        for (var i = 0; i < tabsItems.length; i++) {
            addTabClickListener(tabsItems[i]);
        }

        if (location.hash) {
            goToHash(location.hash);
        } else {
            deletePopupHandler(tabsItems[0]);
        }

        module.callback.goToHash = goToHash;
    }

    var initTabs = function (tabs) {
        if (tabs) {
            // for (var i = 0; i < tabs.length; i++) {
            initTabToggle(tabs);
            // }
        }
    }

    module.callback = {};
    module.callback.init = initTabs;
})